import StorageUtil from './utils/storageUtil.js'
import userInfo from './utils/userInfo.js'
import domUtil from './utils/domUtil.js'
import msgDialog from './utils/msgDialog.js'
import httpUtil from './utils/httpUtil.js'
import formatDate from 'date-any/formatDate.js'
import toDate from 'date-any/toDate.js'
import frequence from './utils/frequence.js'
import serverMap from '../../config/serverMap'
import publicCall from './publicCall.js'
import cookieUtil from './cookieUtil.js'

const util = {
    clone(obj, deep) {
        if (!obj) return obj;
        if (deep) return JSON.parse(JSON.stringify(obj));
        return Array.isArray(obj) ? obj.slice(0) : Object.assign({}, obj)
    },
    noop() {
    },
    storage: new StorageUtil(),
    toDate,
    formatDate,
    userInfo,
    serverMap
}

Object.assign(domUtil, util, msgDialog, httpUtil, frequence, publicCall, cookieUtil)

export default domUtil
